import { getCookiesFromString } from '@/utils/getCookiesFromString';
import { isClient } from '@/utils/isClient';
import { useEffect, useMemo, useState } from 'react';

export interface Cookies {
  [key: string]: string | undefined;
  _ga?: string;
}

export const useCookies = <T extends keyof Cookies & string>(...names: T[]): [Pick<Cookies, T>] => {
  const [cookiesString, setCookiesString] = useState(isClient() ? document.cookie : '');
  const [cookies, setCookies] = useState<Pick<Cookies, T>>(
    getCookiesFromString(cookiesString, names) as Pick<Cookies, T>,
  );

  const handleCookieChanged: EventListener = (event) => {
    if ((event as CustomEvent).detail == cookiesString) return;
    const newCookies = getCookiesFromString(cookiesString, names) as Pick<Cookies, T>;
    if (JSON.stringify(newCookies) === JSON.stringify(cookies)) return; // no change
    setCookiesString((event as CustomEvent).detail);
    setCookies(newCookies);
  };

  useEffect(() => {
    document.addEventListener('cookieChanged', handleCookieChanged);

    return () => {
      document.removeEventListener('cookieChanged', handleCookieChanged);
    };
  }, []);

  return useMemo(() => [cookies], [cookies]);
};

export default useCookies;
